import React from 'react';
import { Heading, NamedLink } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';
import { FaRegCheckCircle } from 'react-icons/fa';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTermsAndConditions = props => {
  const { fields, heading = 'Terms and Conditions', showAsIngress = false } = props;

  const textClass = showAsIngress ? css.ingress : css.text;

  if (!fields || fields.length === 0) {
    return null;
  }

  return (
    <section
      className={css.sectionText}
      id="terms_and_conditions"
      style={{
        borderTop: '1px solid #dfe0e4',
        borderBottom: '1px solid #dfe0e4',
        marginTop: '20px',
        paddingBottom: '10px',
      }}
    >
      {heading ? <h4 style={{ marginBottom: '0' }}>{heading}</h4> : null}

      {fields.map(field => {
        const content = richText(field.text, {
          linkify: true,
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
          longWordClass: css.longWord,
          breakChars: '/',
        });
        const fieldHeading =
          field.key === 'restrictions'
            ? 'Restrictions'
            : field.key === 'vaccination_policy'
            ? 'Pet Vaccination Requirement Policy'
            : field.key === 'dist_radius_charge'
            ? 'Distance Radius & Charges'
            : field.key === 'refund_policy'
            ? 'Cancellation/Refund Policy'
            : field.key === 'injury_policy'
            ? 'Pet Illness/Injury Policy'
            : field.heading;
        return (
          <div key={field.key} className={css.fieldBlock}>
            <Heading as="h2" rootClassName={css.sectionHeading}>
              <FaRegCheckCircle /> {fieldHeading}
            </Heading>
            <p className={textClass} style={{ marginBottom: '10px' }}>
              {content}
            </p>
          </div>
        );
      })}
      <span style={{ fontStyle: 'italic' }}>
        By booking, you agree to the facility's Terms & Conditions and the{' '}
        <NamedLink name="CMSPage" params={{pageId: 'terms-and-conditions'}} to={{ search: '?fromListing=true' }}>
          Purfurry Terms & Conditions
        </NamedLink>
        .
      </span>
    </section>
  );
};

export default SectionTermsAndConditions;
